export default "__VITE_ASSET__CpSWQyBR__"